import React from "react";
import { Select } from "../../UI/Select";
import { usePlacementWorksheetTableContext } from "./PlacementWorksheetTableProvider";

export const ALL_UNIT_OPTION = { value: "all", label: "Show All Units" };

const UNIT_FILTER_OPTIONS = [
  ALL_UNIT_OPTION,
  { value: "filled", label: "Show Filled Units" },
  { value: "unfilled_partial", label: "Show Unfilled & Partial Units" },
];

export const PlacementWorksheetTableFilterSelect = () => {
  const { filterUnit, setFilterUnit } = usePlacementWorksheetTableContext();

  const handleChangeFilterUnit = (selection: any) => {
    setFilterUnit(selection);
  };

  return <Select value={filterUnit} onChange={handleChangeFilterUnit} options={UNIT_FILTER_OPTIONS} />;
};
